import {Box, Button, Menu, Typography} from '@viptech/react-components'
import {startOfMonth, startOfWeek, startOfYear, sub} from 'date-fns'

import moment from 'moment'
import {useEffect, useState} from 'react'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import CalendarIcon from 'src/images/CalendarIcon'

type Props = {
  onChangeFilter: (range: RangeOfDates) => void
  setLabelOnFilter: (label: string) => void
}

type dates = {
  start: string
  end: string
}

export type RangeOfDates = {
  actual: dates
  last: dates
}

function PersonalizedDatesRange(props: Props) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null)
  const [displayName, setDisplayName] = useState<string>('Anual')
  const {onChangeFilter, setLabelOnFilter} = props

  const {styledTheme} = usePersonalizedThemeByCompany()
  const today = new Date()

  useEffect(() => {
    setLabelOnFilter(displayName)
  }, [displayName])

  return (
    <>
      <Button variant='outlined' onClick={(e) => setAnchor(e.currentTarget)} hoverColor='none' color='#9aa4b2' width='130px'>
        <Box display='flex' columnGap='30px' align='center' justifyContent='space-between' width='100%'>
          <CalendarIcon playerBar={false} />
          <Typography variant='p' size='12px' children={displayName} color={styledTheme.colors.text} />
        </Box>
      </Button>
      <Menu anchor={anchor} onClose={() => setAnchor(null)} hideTriangle borderRadius='8px' marginTop='5px'>
        <Box display='flex' direction='column' padding='5px' justify='flex-start' width='120px'>
          <Button
            variant='contained'
            color='transparent'
            hoverColor='#F5F5F5'
            onClick={() => {
              setDisplayName('Semanal')
              const thisDayLastWeek = sub(today, {days: 7})
              const actual = {
                start: moment(startOfWeek(today)).format(),
                end: moment(today.toLocaleString()).format(),
              }

              const last = {
                start: moment(startOfWeek(thisDayLastWeek)).format(),
                end: moment(thisDayLastWeek).format(),
              }
              onChangeFilter({actual, last})
              setAnchor(null)
            }}>
            <Box display='flex' columnGap='8px' align='center' justify='flex-start' fontSize='12px' width='100%'>
              <span style={{color: '#364152', fontSize: '12px'}}>Semanal</span>
            </Box>
          </Button>

          <Button
            variant='contained'
            color='transparent'
            hoverColor='#F5F5F5'
            onClick={() => {
              setDisplayName('Mensal')
              const thisDayLastMonth = sub(today, {months: 1})
              const actual = {
                start: moment(startOfMonth(today)).format(),
                end: moment(today.toLocaleString()).format(),
              }

              const last = {
                start: moment(startOfMonth(thisDayLastMonth)).format(),
                end: moment(thisDayLastMonth).format(),
              }
              onChangeFilter({actual, last})
              setAnchor(null)
            }}>
            <Box display='flex' columnGap='8px' align='center' justify='flex-start' fontSize='12px' width='100%'>
              <span style={{color: '#364152', fontSize: '12px'}}>Mensal</span>
            </Box>
          </Button>

          <Button
            variant='contained'
            color='transparent'
            hoverColor='#F5F5F5'
            onClick={() => {
              setDisplayName('Anual')
              const thisDayLastYear = sub(today, {years: 1})
              const actual = {
                start: moment(startOfYear(today)).format(),
                end: moment(today.toLocaleString()).format(),
              }

              const last = {
                start: moment(startOfYear(thisDayLastYear)).format(),
                end: moment(thisDayLastYear).format(),
              }
              onChangeFilter({actual, last})
              setAnchor(null)
            }}>
            <Box display='flex' columnGap='8px' align='center' justify='flex-start' fontSize='12px' width='100%'>
              <span style={{color: '#364152', fontSize: '12px'}}>Anual</span>
            </Box>
          </Button>
        </Box>
      </Menu>
    </>
  )
}

export default PersonalizedDatesRange
